import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateLoader } from '@cfp/core';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
  selector: 'cfp-self-onboarding-verify-account',
  templateUrl: './self-onboarding-verify-account.html',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelfOnboardingVerifyAccount {
  private readonly translateLoader = inject(TranslateLoader);
  protected readonly isTranslationLoaded = toSignal(
    this.translateLoader.loadTranslation('self-onboarding').pipe(map(() => true))
  );
}
